export const RouteUrls = {
    Dashboard: '/dashboard',
    Login: '/login',
    Admin: {
        Login: 'login',
        Manage: {
            Users: 'users',
            Statistics: 'statistics',
        }, 
    },
    SignUp: '/signup/:affiliate?',
    AccountCreated: '/account-created',
    PasswordReset: '/password-reset/:locator/:token',
    Settings: {
        AccountInfo: 'accountinfo',
        Password: 'password',
        Membership: 'membership',
        Notifications: 'notifications',
        Policies: 'policies/:page'
    },
    Marketplace: {
        Posting: 'posting/:locator/:mode?',
        Search: 'search',
        All: ':title'
    },
    Profile: {
        Client: 'client/:locator?',
        Talent: 'talent/:locator?'
    },
    Wallet: '/wallet',
    JobPostings:{
        Applications: 'applications/:locator',
        Posting: 'posting/:locator/:mode?'
    },
    Applications: 'applications',
    Messages: '/messages',
    Bookmarks: '/bookmarks',
    ActiveJobs: '/active-jobs'
}
